<script>
export default {
  name: 'ReportSchedule',
  props: {
    reportName: { required: true, type: String },
    reportParameters: { type: Object },
    chartType: { type: String }
  },
  methods: {
    setFormData() {
      this.formTypes.schedule.form.schema.find(
        field => field.name == 'reportName'
      ).default = this.reportName
      this.formTypes.schedule.form.schema.find(
        field => field.name == 'scheduleFilter'
      ).default = this.reportParameters
      this.formTypes.schedule.form.schema.find(
        field => field.name == 'scheduleChartType'
      ).default = this.chartType
    },
    afterSave() {
      this.$bvModal.hide('schedule-report-modal')
      this.$root.$emit('refresh-nav') // make sure the schedules show up in the menu
    }
  }
}
</script>

<template>
  <b-modal
    id="schedule-report-modal"
    title="Schedule Report"
    size="xl"
    hide-footer
    @show="setFormData"
  >
    <GraphQLFormEdit
      formType="schedule"
      ref="schedule-form"
      :redirects="false"
      @formSaved="afterSave"
    />
  </b-modal>
</template>
